import React from 'react'
import { Spinner } from '../../../ui/spinner'
import Breadcrumb from '../shared/Breadcrumb'

const MaskCreationForm = ({
  maskName,
  maskPrompt,
  maskNegativePrompt,
  adjustmentFactor,
  isCreatingMask,
  onMaskNameChange,
  onMaskPromptChange,
  onMaskNegativePromptChange,
  onAdjustmentFactorChange,
  onCancel,
  onSubmit,
  onNavigate
}) => {
  const breadcrumbItems = [
    { id: 'tools', label: 'Tools' },
    { id: 'inpainting', label: 'Generative Inpainting' },
    { id: 'create-mask', label: 'Create Mask' }
  ]

  return (
    <div className="space-y-4 mt-4">
      <Breadcrumb 
        items={breadcrumbItems}
        onNavigate={onNavigate}
      />

      {/* Adjustment Factor Slider */}
      <div className="space-y-2">
        <div className="flex justify-between items-center">
          <label className="block text-sm font-medium text-gray-200">
            Mask Adjustment
          </label>
          <span className="text-sm text-gray-400">
            {adjustmentFactor}
          </span>
        </div>
        <p className="text-xs text-gray-400">
          Adjust how aggressively the mask is applied
        </p>
        <div className="mt-3">
          <input
            type="range"
            min="-100"
            max="100"
            value={adjustmentFactor}
            onChange={(e) => onAdjustmentFactorChange(parseInt(e.target.value))}
            className="w-full h-1 bg-gray-600 rounded-lg appearance-none cursor-pointer"
          />
        </div>
        <div className="flex justify-between text-xs text-gray-500 mt-1">
          <span>More subtle</span>
          <span>More intense</span>
        </div>
      </div>

      {/* Mask Prompt */}
      <div className="space-y-2">
        <label className="block text-sm font-medium text-gray-200">
          Mask Prompt
        </label>
        <p className="text-xs text-gray-400">
          Describe the objects that you want to change in the image, separated by commas.
        </p>
        <textarea
          value={maskPrompt}
          onChange={(e) => onMaskPromptChange(e.target.value)}
          className="w-full p-3 bg-gray-700 rounded-md border border-gray-600 
            text-white resize-none text-sm focus:border-blue-500 
            focus:ring-1 focus:ring-blue-500 transition-colors"
          rows="3"
          placeholder="e.g., red car, traffic light, street sign"
        />
      </div>

      {/* Negative Prompt */}
      <div className="space-y-2">
        <label className="block text-sm font-medium text-gray-200">
          Negative Prompt
        </label>
        <p className="text-xs text-gray-400">
          Describe the objects that you want to retain in the image, separated by commas.
        </p>
        <textarea
          value={maskNegativePrompt}
          onChange={(e) => onMaskNegativePromptChange(e.target.value)}
          className="w-full p-3 bg-gray-700 rounded-md border border-gray-600 
            text-white resize-none text-sm focus:border-blue-500 
            focus:ring-1 focus:ring-blue-500 transition-colors"
          rows="3"
          placeholder="e.g., buildings, people, trees"
        />
      </div>

      {/* Mask Name Input */}
      <div className="space-y-2">
        <label className="block text-sm font-medium text-gray-200">
          Mask Name
        </label>
        <input
          type="text"
          value={maskName}
          onChange={(e) => onMaskNameChange(e.target.value)}
          placeholder="Enter a name for this mask"
          className="w-full p-2 bg-gray-700 rounded-md border border-gray-600 
            text-white text-sm focus:border-blue-500 focus:ring-1 
            focus:ring-blue-500 transition-colors"
        />
      </div>

      {/* Create Mask Button */}
      <button
        onClick={onSubmit}
        disabled={!maskPrompt.trim() || isCreatingMask}
        className={`w-full p-2 rounded transition-colors flex items-center justify-center gap-2 ${
          maskPrompt.trim() && !isCreatingMask
            ? 'bg-blue-600 hover:bg-blue-500' 
            : 'bg-gray-700 cursor-not-allowed opacity-50'
        }`}
      >
        {isCreatingMask ? (
          <>
            <Spinner className="mr-2" />
            <span>Generating Mask...</span>
          </>
        ) : (
          'Create Mask'
        )}
      </button>
    </div>
  )
}

export default MaskCreationForm 